import React from "react"
import styled from "styled-components"
import { colors} from "buoy-theme"
import { Paragraph, Dropdown, FormInput } from "buoy-core"

const RowText = styled(Paragraph)`
  margin: 0;
`

const Input = styled(FormInput)`
  &:disabled {
    color: ${colors.neutral};
  }
`

const FormField = ({
  text,
  placeholder,
  options,
  value,
  onChange,
  isEditing,
  disableDropdown,
}) => (
  <React.Fragment>
    {isEditing ? (
      disableDropdown ? (
        // use disabled input to show value but prevent dropdown editing
        <Input
          placeholder={placeholder}
          value={text}
          disabled
        />
      ) : (
        <Dropdown
          onChange={onChange}
          value={value}
          options={options}
          placeholder={placeholder}
        />
      )
    ) : (
      text && <RowText>{text}</RowText>
    )}
  </React.Fragment>
)

export { FormField as default}


// WEBPACK FOOTER //
// ./assets/common/components/PlanDetails/components/FormField.js